// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c82smr{font:var(--ds-font-body,normal 400 14px/20px ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._18zr1ejb{padding-inline:var(--ds-space-300,24px)}\n._1rjcv77o{padding-block:var(--ds-space-025,2px)}\n._16jlkb7n{flex-grow:1}\n._1o9zkb7n{flex-shrink:1}\n._i0dl1wug{flex-basis:auto}", ""]);
// Exports
module.exports = exports;
